<template>
  <div>
    <div class="custom-tree-container">
      <div class="custom-tree-container" style="padding: 10px;">
        <div class="block">
          <el-tree
            :data="settingsMenu"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            draggable
            :allow-drop="allowDrop"
            :allow-drag="allowDrag"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button
                  type="text"
                  size="mini"
                  class="table-operations"
                  @click="() => appendApplication(data)"
                >
                  + Liegenschaft
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  class="table-operations"
                  @click="() => appendChild(data)"
                >
                  + Kindelement
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  class="table-operations"
                  @click="() => remove(node, data)"
                >
                  Löschen
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="saveBtn">
      <el-button
        @click="addFirstItem()"
        v-if="addFirst"
        class="sbh-button-light"
      >
        <i class="fas fa-plus"></i>
      </el-button>
      <el-button
        @click="saveMenu()"
        icon="el-icon-circle-check-outline"
        class="sbh-button-light"
      >
        Speichern
      </el-button>
    </div>

    <el-dialog
      title="Erste Menüpunkt hinzufügen"
      :visible.sync="addFirstDialog"
      @close="addFirstNodeToMenu"
      :before-close="handleClose"
    >
      <el-form :model="firstItemForm">
        <el-form-item label="Name" :label-width="formLabelWidth">
          <el-input v-model="firstItemForm.name" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFirstDialog = false" class="sbh-button-light">
          Abbrechen
        </el-button>
        <el-button
          type="primary"
          @click="addFirstDialog = false"
          class="sbh-button"
        >
          OK
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Application hinzufügen"
      :visible.sync="addApplicationDialog"
      @close="addApplicationNodeToMenu"
      :before-close="handleClose"
    >
      <el-form :model="applicationForm">
        <el-form-item label="Name" :label-width="formLabelWidth">
          <el-input
            v-model="applicationForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Niota Application ID"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="applicationForm.applicationId"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addApplicationDialog = false"
          class="sbh-button-light"
        >
          Abbrechen
        </el-button>
        <el-button
          type="primary"
          @click="addApplicationDialog = false"
          class="sbh-button"
        >
          OK
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Kindelement hinzufügen"
      :visible.sync="addChildDialog"
      @close="addChildNodeToMenu"
      :before-close="handleClose"
    >
      <el-form :model="childForm">
        <el-form-item label="Name" :label-width="formLabelWidth">
          <el-input v-model="childForm.name" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addChildDialog = false" class="sbh-button-light">
          Abbrechen
        </el-button>
        <el-button
          type="primary"
          @click="addChildDialog = false"
          class="sbh-button"
        >
          OK
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import customService from "../services/custom-service";

export default {
  name: "contentSettings",
  props: {
    settingsMenu: Array,
    custom02: Boolean,
    addFirst: Boolean
  },
  mounted() {
    this.$nextTick(function() {
      this.selectMenuId();
    });
  },
  data() {
    return {
      addFirstDialog: false,
      addApplicationDialog: false,
      addChildDialog: false,
      newLabel: "",
      firstItemForm: {
        name: ""
      },
      applicationForm: {
        name: "",
        applicationId: ""
      },
      childForm: {
        name: ""
      },
      formLabelWidth: "160px",
      menuId: 2000
    };
  },

  methods: {
    addFirstNodeToMenu() {
      let newChild = {
        id: this.menuId++,
        label: this.firstItemForm.name,
        children: []
      };
      if (this.firstItemForm.name !== "") {
        this.settingsMenu.push(newChild);
      }
      this.firstItemForm.name = "";
    },

    addApplicationNodeToMenu() {
      let newChild = {
        id: this.menuId++,
        label: this.applicationForm.name,
        applicationId: this.applicationForm.applicationId,
        children: []
      };
      if (!this.addMenuNode.children) {
        this.$set(this.addMenuNode, "children", []);
      }
      if (this.applicationForm.name !== "") {
        this.addMenuNode.children.push(newChild);
      }
      this.applicationForm.name = "";
      this.applicationForm.applicationId = "";
    },

    addChildNodeToMenu() {
      let newChild = {
        id: this.menuId++,
        label: this.childForm.name,
        children: []
      };
      if (!this.addMenuNode.children) {
        this.$set(this.addMenuNode, "children", []);
      }
      if (this.childForm.name !== "") {
        this.addMenuNode.children.push(newChild);
      }
      this.childForm.name = "";
    },

    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
        .then(() => {
          done();
        })
        .catch(() => {});
    },

    addFirstItem() {
      this.addFirstDialog = true;
    },

    saveMenu() {
      this.$emit("saveMenu");
    },

    append(data) {
      let newChild = { id: this.menuId++, label: "test", children: [] };
      this.openInputModal()
        .then(text => {
          if (!text) {
            return null;
          }
          if (!data.children) {
            this.$set(data, "children", []);
          }
          newChild.label = text;
          data.children.push(newChild);
        })
        .catch(() => {
          return null;
        });
    },

    appendFirstItem(data) {
      this.addMenuNode = data;
      this.addFirstDialog = true;
    },

    appendApplication(data) {
      this.addMenuNode = data;
      this.addApplicationDialog = true;
    },

    appendChild(data) {
      this.addMenuNode = data;
      this.addChildDialog = true;
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },

    openInputModal() {
      return this.$prompt("Text eingeben", "Beschreibung", {
        confirmButtonText: "OK",
        cancelButtonText: "Abbrechen"
      })
        .then(result => {
          this.$notify({
            type: "success",
            message: "Eintrag angelegt: " + result.value,
            position: "bottom-right"
          });
          return result.value;
        })
        .catch(() => {
          this.$notify({
            type: "info",
            message: "Eingabe abgebrochen",
            position: "bottom-right"
          });
        });
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "Level two 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("Level three 3-1-1") === -1;
    },
    selectMenuId() {
      let menuItem = this.settingsMenu[0];
      if (menuItem && menuItem.id > 1000) {
        if (menuItem.children) {
          var result = customService.mappLastId(menuItem.children);
          this.menuId = result + 100;
        }
      }
    }
  }
};
</script>
